<template>
  <div class="container page">
      <van-nav-bar :title="$t('kefu.title')">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
 
    <div class="servicelistItem">
        <div class="servicelistItemTop">
          <img class="servicelistItemImage" src="img/mine/kefu.png">
          <div class="servicelistItemText">{{this.$store.getters.getBaseInfo.name !==undefined ?this.$store.getters.getBaseInfo.name:$t('kefu.defaultName')}}</div>
          <div class="servicelistItemBtn" @click="toServicePage()">
            <div class="servicelistItemBtnText">
              {{$t('kefu.lianxi')}}
            </div>
          </div>
        </div>
        <div class="servicelistItemBottom">
        <div class="servicelistItemInfoText">
          {{$t('kefu.content')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    toServicePage(){
      this.$router.push("ServicePage");
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-nav-bar {
    z-index: 999;
    position: relative;
    background: url(/img/header.svg) no-repeat 50%/100%;
}
.servicelistItem{
  display: flex;
  flex-direction: column;
  height: 200px;
  padding: 30px 30px;
  margin: 30px 20px;
  border-radius: 20px;
  justify-content: space-between;
  background: #fff;
}
.servicelistItem .servicelistItemTop{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  gap: 16px;
  min-width: 0;
}
.servicelistItem .servicelistItemTop .servicelistItemImage{
  width: 80px;
  height: 80px;
  border-radius: 50%;
  flex-shrink: 0;
}
.servicelistItem .servicelistItemTop .servicelistItemText{
  margin-left: 0;
  font-size: 36px;
  font-weight: 700;
  color: #000;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.25;
}
.servicelistItem .servicelistItemTop .servicelistItemBtn{
  display: flex;
  width: 150px;
  height: 55px;
  flex-shrink: 0;
  border-radius: 30px;
  align-items: center;
  justify-content: center;
  background: linear-gradient(30deg,#7d76ef,#d63f8c);
}
.servicelistItem .servicelistItemTop .servicelistItemBtn .servicelistItemBtnText{
  color: #fff;
  font-size: 24px;
  white-space: nowrap;
}
.servicelistItem .servicelistItemBottom{
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50px;
  padding: 12px;
  background: #f2f2f5;
  border-radius: 10px;
  color: #979799;
  min-width: 0;
  box-sizing: border-box;
}
.servicelistItem .servicelistItemBottom .servicelistItemInfoText{
  width: 100%;
  max-width: 100%;
  font-size: 26px;
  line-height: 1.35;
  text-align: center;
  word-break: break-word;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
